export const GET_PROJECT_AI_SUMMARY_REQUEST = 'GET_PROJECT_AI_SUMMARY_REQUEST';
export const REQUEST_PROJECT_AI_SUMMARY_REQUEST = 'REQUEST_PROJECT_AI_SUMMARY_REQUEST';
export const GET_DAILY_ACTIVITY_AI_SUMMARY_REQUEST = 'GET_DAILY_ACTIVITY_AI_SUMMARY_REQUEST';
export const REQUEST_DAILY_ACTIVITY_AI_SUMMARY_REQUEST = 'REQUEST_DAILY_ACTIVITY_AI_SUMMARY_REQUEST';
export const GET_WEEKLY_ACTIVITY_AI_SUMMARY_REQUEST = 'GET_WEEKLY_ACTIVITY_AI_SUMMARY_REQUEST';
export const REQUEST_WEEKLY_ACTIVITY_AI_SUMMARY_REQUEST = 'REQUEST_WEEKLY_ACTIVITY_AI_SUMMARY_REQUEST';
export const GET_MONTHLY_ACTIVITY_AI_SUMMARY_REQUEST = 'GET_MONTHLY_ACTIVITY_AI_SUMMARY_REQUEST';
export const REQUEST_MONTHLY_ACTIVITY_AI_SUMMARY_REQUEST = 'REQUEST_MONTHLY_ACTIVITY_AI_SUMMARY_REQUEST';
export const GET_END_OF_DAY_CHECKLIST_REQUEST = 'GET_END_OF_DAY_CHECKLIST_REQUEST';
export const REGENERATE_QUOTE_REQUEST = 'REGENERATE_QUOTE_REQUEST';
export const GET_SUGGESTIONS_REQUEST = 'GET_SUGGESTIONS_REQUEST';
export const GET_SUGGESTION_DETAIL_REQUEST = 'GET_SUGGESTION_DETAIL_REQUEST';
export const APPROVE_SUGGESTION_REQUEST = 'APPROVE_SUGGESTION_REQUEST';
export const REJECT_SUGGESTION_REQUEST = 'REJECT_SUGGESTION_REQUEST';
export const GET_SUGGESTION_RECIPIENTS_REQUEST = 'GET_SUGGESTION_RECIPIENTS_REQUEST';
export const REDIRECT_SUGGESTION_REQUEST = 'REDIRECT_SUGGESTION_REQUEST';
export const GENERATE_SUGGESTIONS_REQUEST = 'GENERATE_SUGGESTIONS_REQUEST';
export const ASK_AI_QUESTION_REQUEST = 'ASK_AI_QUESTION_REQUEST';
export const GET_AI_ANSWER_REQUEST = 'GET_AI_ANSWER_REQUEST';
export const GET_AI_CONVERSATION_REQUEST = 'GET_AI_CONVERSATION_REQUEST';
export const EXPORT_AI_CONVERSATION_REQUEST = 'EXPORT_AI_CONVERSATION_REQUEST';

export const getProjectAiSummary = (projectId, callback) => ({
    type: GET_PROJECT_AI_SUMMARY_REQUEST,
    payload: { projectId, callback },
});

export const requestProjectAiSummary = (projectId, callback) => ({
    type: REQUEST_PROJECT_AI_SUMMARY_REQUEST,
    payload: { projectId, callback },
});

export const getDailyActivityAiSummary = (date, callback) => ({
    type: GET_DAILY_ACTIVITY_AI_SUMMARY_REQUEST,
    payload: { date, callback },
});

export const requestDailyActivityAiSummary = (date, callback) => ({
    type: REQUEST_DAILY_ACTIVITY_AI_SUMMARY_REQUEST,
    payload: { date, callback },
});

export const getWeeklyActivityAiSummary = (weekStart, callback) => ({
    type: GET_WEEKLY_ACTIVITY_AI_SUMMARY_REQUEST,
    payload: { weekStart, callback },
});

export const requestWeeklyActivityAiSummary = (weekStart, callback) => ({
    type: REQUEST_WEEKLY_ACTIVITY_AI_SUMMARY_REQUEST,
    payload: { weekStart, callback },
});

export const getMonthlyActivityAiSummary = (month, callback) => ({
    type: GET_MONTHLY_ACTIVITY_AI_SUMMARY_REQUEST,
    payload: { month, callback },
});

export const requestMonthlyActivityAiSummary = (month, callback) => ({
    type: REQUEST_MONTHLY_ACTIVITY_AI_SUMMARY_REQUEST,
    payload: { month, callback },
});

export const getEndOfDayChecklist = (date, callback) => ({
    type: GET_END_OF_DAY_CHECKLIST_REQUEST,
    payload: { date, callback },
});

export const regenerateQuote = (quoteId, options, callback) => ({
    type: REGENERATE_QUOTE_REQUEST,
    payload: { quoteId, options, callback },
});

export const getSuggestions = (params, callback) => ({
    type: GET_SUGGESTIONS_REQUEST,
    payload: { params, callback },
});

export const getSuggestionDetail = (suggestionId, callback) => ({
    type: GET_SUGGESTION_DETAIL_REQUEST,
    payload: { suggestionId, callback },
});

export const approveSuggestion = (suggestionId, reason, callback) => ({
    type: APPROVE_SUGGESTION_REQUEST,
    payload: { suggestionId, reason, callback },
});

export const rejectSuggestion = (suggestionId, reason, callback) => ({
    type: REJECT_SUGGESTION_REQUEST,
    payload: { suggestionId, reason, callback },
});

export const getSuggestionRecipients = (suggestionId, callback) => ({
    type: GET_SUGGESTION_RECIPIENTS_REQUEST,
    payload: { suggestionId, callback },
});

export const redirectSuggestion = (suggestionId, userId, callback) => ({
    type: REDIRECT_SUGGESTION_REQUEST,
    payload: { suggestionId, userId, callback },
});

export const generateSuggestions = (callback) => ({
    type: GENERATE_SUGGESTIONS_REQUEST,
    payload: { callback },
});

export const askAiQuestion = (question, conversationId, callback) => ({
    type: ASK_AI_QUESTION_REQUEST,
    payload: { question, conversationId, callback },
});

export const getAiAnswer = (contextId, callback) => ({
    type: GET_AI_ANSWER_REQUEST,
    payload: { contextId, callback },
});

export const getAiConversation = (conversationId, callback) => ({
    type: GET_AI_CONVERSATION_REQUEST,
    payload: { conversationId, callback },
});

export const exportAiConversation = (conversationId, format, title, callback) => ({
    type: EXPORT_AI_CONVERSATION_REQUEST,
    payload: { conversationId, format, title, callback },
});
